import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ToastEffects } from './toast.effects';
import { IToastFeature } from './toast.feature.state';
import { toastReducer } from './toast.reducer';

@NgModule({
  imports: [StoreModule.forFeature(nameof<IToastFeature>('toastFeature'), toastReducer), EffectsModule.forFeature([ToastEffects])],
})
export class ToastStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: ToastStateModule
  ) {
    if (parentModule) {
      throw new Error('ToastStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
